<template>
  <Transition name="fade">
    <!-- Overlay que bloquea toda la pantalla -->
    <div v-if="show" class="loader-overlay">
      <div class="loader-content">
        <!-- Contenedor del logo y el anillo -->
        <div class="logo-wrapper">
          <!-- Anillo giratorio -->
          <div class="spinner-ring"></div>

          <!-- Logo principal central -->
          <img
            src="@/assets/images/logo_principal.png"
            alt="Logo Xhidenxhi"
            class="central-logo"
          />
        </div>
        <p class="loading-text">Procesando registro...</p>
      </div>
    </div>
  </Transition>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
/* Fondo con efecto Blur y Transparencia */
.loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7); /* Oscuro transparente */
  backdrop-filter: blur(8px); /* Efecto de desenfoque */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999; /* Asegura que esté por encima de todo */
}

.loader-content {
  text-align: center;
}

.logo-wrapper {
  position: relative;
  width: 150px;
  height: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto 20px;
}

/* El anillo que gira alrededor */
.spinner-ring {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 4px solid transparent;
  border-top: 4px solid #2e7d32; /* Verde del banner */
  border-right: 4px solid #2e7d32;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

/* Estilo del logo logo_principal.png */
.central-logo {
  width: 80%;
  height: 80%;
  object-fit: contain;
  border-radius: 50%; /* Como logo_principal.png es circular */
  z-index: 2;
}

.loading-text {
  color: white;
  font-family: 'Staatliches', cursive;
  letter-spacing: 2px;
  text-transform: uppercase;
  margin-top: 15px;
}

/* Animación de rotación */
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Transición suave de aparición/desaparición */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
</style>
